<template>
  <v-bottom-navigation fixed height="96" style="box-shadow: none">
    <v-row class="ma-0 py-5 px-6 btn-fixed-wrapper">
      <v-col cols="12">
        <v-btn
          block
          elevation="0"
          class="btn-fixed btn-blue"
          color="blue"
          @click="submit()"
          ><span class="white--text">신청하기</span></v-btn
        >
      </v-col>
    </v-row>
  </v-bottom-navigation>
</template>

<script>
import applCode from '@/const/applCodeConstants';
import { mapGetters, mapMutations } from 'vuex';
import routerConstants from '@/const/routerConstants';


export default {
  computed: {
    ...mapGetters('ELA', [
      'GET_SEARCH_APPL_CD',
      'GET_APPL_USER_LIST',
      'GET_MGR_USER_LIST',
    ]),
    ...mapGetters(['GET_USER_DATA', 'GET_APPL_CD','GET_TIM_APPL_SEQ']),

  },
  methods: {
    ...mapMutations('SPINNER', ['ON_APP_SPINNER', 'OFF_APP_SPINNER']),
    // 신청
    async submit() {
      try {



        if (this.GET_SEARCH_APPL_CD === applCode.Vacation) {
          const response = await this.$store.dispatch('ELA/SAVE_VACATION_DET');
          if (!response) return false;
        }

        if (this.GET_SEARCH_APPL_CD === applCode.OtWork) {
          const response = await this.$store.dispatch('ELA/SAVE_OT_WORK_DET');
          if (!response) return false;
        }

        if (this.GET_SEARCH_APPL_CD === applCode.Schedule) {
          const response = await this.$store.dispatch('ELA/SAVE_SCHEDULE_DET');
          if (!response) return false;
        }

        if (this.GET_SEARCH_APPL_CD === applCode.Reward) {
          // 보상휴가
          const response = await this.$store.dispatch('ELA/SAVE_REWARD_DET');
          if (!response) return false;
        }

        if (this.GET_SEARCH_APPL_CD === applCode.Attend) {
          // 출퇴근변경
          const response = await this.$store.dispatch('ELA/SAVE_ATTEND_DET');
          if (!response) return false;
        }

        if (
          this.GET_SEARCH_APPL_CD === applCode.CancelVacation ||
          this.GET_SEARCH_APPL_CD === applCode.CancelReward
        ) {
          // 취소신청
          const response = await this.$store.dispatch('ELA/SAVE_CANCEL_DET');
          if (!response) return false;
        }

        let response = {};
        if (this.GET_SEARCH_APPL_CD === applCode.Vaccination) {
          // 독감예방접종신청
          const params = {
            appls: this.GET_APPL_USER_LIST,
            inusers: this.GET_MGR_USER_LIST,
            searchApplSabun: this.GET_USER_DATA.ssnSabun,
          };
          response = await this.$store.dispatch(
            'ELA/SAVE_VACCINATION_DET',
            params,
          );

          if (!response) return false;
        }

        if (this.GET_SEARCH_APPL_CD === applCode.EdusApp) {
          // 학자금신청
          const params = {
            appls: this.GET_APPL_USER_LIST,
            inusers: this.GET_MGR_USER_LIST,
            searchApplSabun: this.GET_USER_DATA.ssnSabun,
          };

          response = await this.$store.dispatch('ELA/SAVE_EDUSAPP_DET', params);

          if (!response) return false;
        }

        if (
          this.GET_SEARCH_APPL_CD === applCode.LeaAbsParental ||
          this.GET_SEARCH_APPL_CD === applCode.LeaAbsFamily ||
          this.GET_SEARCH_APPL_CD === applCode.LeaAbsInfertility ||
          this.GET_SEARCH_APPL_CD === applCode.LeaAbsSick ||
          this.GET_SEARCH_APPL_CD === applCode.LeaAbsCasualty ||
          this.GET_SEARCH_APPL_CD === applCode.LeaAbsNew ||
          this.GET_SEARCH_APPL_CD === applCode.LeaAbsApplication ||
          this.GET_SEARCH_APPL_CD === applCode.LeaAbsExtension ||
          this.GET_SEARCH_APPL_CD === applCode.LeaAbsAdd ||
          this.GET_SEARCH_APPL_CD === applCode.eaAbsExtension
        ) {
          // 휴/복직신청
          const params = {
            appls: this.GET_APPL_USER_LIST,
            inusers: this.GET_MGR_USER_LIST,
            searchApplSabun: this.GET_USER_DATA.ssnSabun,
            vacationAtOnceTimKey: this.GET_TIM_APPL_SEQ, 
          };

          response = await this.$store.dispatch('ELA/SAVE_LEAABS_DET', params);

          if (!response) return false;
        }

        if (
          this.GET_SEARCH_APPL_CD === applCode.HolReplaceApp &&
          this.GET_APPL_CD !== applCode.HolReplaceBoxView
        ) {
          // 휴일근무사전대체신청
          const params = {
            appls: this.GET_APPL_USER_LIST,
            inusers: this.GET_MGR_USER_LIST,
            searchApplSabun: this.GET_USER_DATA.ssnSabun,
          };
          response = await this.$store.dispatch(
            'ELA/SAVE_HOL_REPLACE_DET',
            params,
          );

          if (!response) return false;
        }

        if (
          this.GET_SEARCH_APPL_CD === applCode.HolReplaceApp &&
          this.GET_APPL_CD === applCode.HolReplaceBoxView
        ) {
          // 휴일근무사전대체취소신청
          const params = {
            appls: this.GET_APPL_USER_LIST,
            inusers: this.GET_MGR_USER_LIST,
            searchApplSabun: this.GET_USER_DATA.ssnSabun,
          };
          response = await this.$store.dispatch(
            'ELA/SAVE_HOL_REPLACE_CANCEL_DET',
            params,
          );

          if (!response) return false;
        }

        if (
          this.GET_SEARCH_APPL_CD === applCode.ReCertTenureAppView ||
          this.GET_SEARCH_APPL_CD === applCode.ReCertTenureEngAppView ||
          this.GET_SEARCH_APPL_CD === applCode.ReCertTenureTax1AppView ||
          this.GET_SEARCH_APPL_CD === applCode.ReCertTenureTax2AppView ||
          this.GET_SEARCH_APPL_CD === applCode.ReCertLeaveAppView ||
          this.GET_SEARCH_APPL_CD === applCode.ReCertGabTaxView
        ) {
          // 재직증명신청
          const params = {
            appls: this.GET_APPL_USER_LIST,
            inusers: this.GET_MGR_USER_LIST,
            searchApplSabun: this.GET_USER_DATA.ssnSabun,
          };
          response = await this.$store.dispatch('ELA/SAVE_RECERT_DET', params);

          if (!response) return false;
        }

        if (this.GET_SEARCH_APPL_CD === applCode.WorkScheduleTime1) {
          // 시차출퇴근제
          const params = {
            appls: this.GET_APPL_USER_LIST,
            inusers: this.GET_MGR_USER_LIST,
            searchApplSabun: this.GET_USER_DATA.ssnSabun,
          };

          this.ON_APP_SPINNER();

          response = await this.$store.dispatch(
            'ELA/SET_WORK_SCHEDULE_TIME_DET',
            params,
          );

          this.OFF_APP_SPINNER();

          if (!response) return false;
        }

        if (this.GET_SEARCH_APPL_CD === applCode.Vacations || this.GET_SEARCH_APPL_CD === applCode.VacationsCancel ) {
          // 근태/휴가신청
          const params = {
            appls: this.GET_APPL_USER_LIST,
            inusers: this.GET_MGR_USER_LIST,
            searchApplSabun: this.GET_USER_DATA.ssnSabun,
          };

          response = await this.$store.dispatch(
            'ELA/SAVE_VACATIONS_DET',
            params,
          );

          if (!response) return false;
        }
        //BGF웹쪽으로 변환 되어 사용하지 않음
        //const response = await this.$store.dispatch('ELA/SAVE_APPL_APPROVAL');

        // 신청 완료화면으로
        // dialog로 변경 예정

        if (response.data.message === 'OK' && response.data.data.Code == '1') {
          this.$router.push(routerConstants.ApplicationConfirm);
        } else {
          alert(response.data.data.Message);
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>

<style></style>
